// eslint-disable-next-line import/no-unresolved
import 'respimage';
import 'lazysizes';
import 'lazysizes/plugins/bgset/ls.bgset';
import 'lazysizes/plugins/blur-up/ls.blur-up';



// WEBPACK FOOTER //
// ./src/scripts/modules/lazyload.js